<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <CCardHeader>
        <CCol col="6" style="font-size: 25px;">عرض القسم الرئيسي</CCol>
      </CCardHeader>
      <CCardBody>
        <div class="row">
            <div class="col-md-6">
                <table class="table table-bordered">
                     <tr>
                    <th>أيقونة القسم</th>
                    <td><img style="border-radius: 50%;" :src="category.icon_full_path" width="50px" height="50px"></td>
                  </tr>
                  <tr>
                    <th>الإسم</th>
                    <td>{{ category.name }}</td>
                  </tr>
                  <tr>
                    <th> الإسم بالعربي</th>
                    <td>{{ category.name_ar }}</td>
                  </tr>
                  <tr>
                    <th>الوصف</th>
                    <td>{{ category.description }}</td>
                  </tr>
                  <tr>
                    <th>الوصف بالعربي</th>
                    <td>{{ category.description_ar }}</td>
                  </tr>
                </table>
            </div>
        </div>
        <CButton color="warning" @click="goBack">رجوع</CButton>
      </CCardBody>
    </CCard>
  </CCol>
</CRow>
</template>

<script>
export default {
  name: 'ShowCategory',
  data () {
    return {
      category: []
    }
  },
  created () {
    console.log(this.$route.params.id)
    this.$http
      .get(`${this.$hostUrl}categories/${this.$route.params.id}/edit`)
      .then((response) => {
        this.category = response.data.data.category
      })
  },
  methods: {
    goBack () {
      this.categoriesOpened ? this.$router.go(-1) : this.$router.push({ path: '/categories' })
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
</style>
